import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import IconHome from "../../../styles/icons/IconHome";
import listenForOutsideClick from "../../../utils/helpers/helperMethods/ClickOutside";

interface DropdownMenuItem {
  name: string;
  navigation: string;
  icon?: string;
  show?: boolean;
  url?: string;
}

interface Props {
  menuItemName: string;
  dropdownMenuList: DropdownMenuItem[];
  isOpen: boolean;
  handleSetSelectedDropdownMenu: (name: string) => void;
  selectedDropdownMenu: string;
}

const DropdownMenuController = ({
  menuItemName,
  dropdownMenuList,
  isOpen,
  handleSetSelectedDropdownMenu,
  selectedDropdownMenu,
}: Props) => {
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [listening, setListening] = useState(false);
  const [internalOpen, setInternalOpen] = useState(false);

  useEffect(() => {
    setInternalOpen(isOpen);
  }, [isOpen]);

  useEffect(
    listenForOutsideClick(listening, setListening, menuRef, setInternalOpen),
    [listening]
  );

  useEffect(() => {
    if (!internalOpen && isOpen) {
      // no-op: parent controls actual open state
    }
  }, [internalOpen, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="bottom-section" ref={menuRef}>
      <div className="dropdown-menu">
        {dropdownMenuList.map(
          (item, index) =>
            item.show !== false && (
              <Link
                className="list-styles"
                to={item.navigation}
                key={`${menuItemName}-${item.name}-${
                  item.navigation || item.url || "no-nav"
                }-${index}`}
                onClick={() => handleSetSelectedDropdownMenu(item.name)}
              >
                <div className="menu-item">
                  {item.icon && (
                    <div className="logo">
                      <IconHome breadcrumb={item.icon} activeColor="#4FD5F2" />
                    </div>
                  )}

                  <div
                    className={`menu-item-name ${
                      selectedDropdownMenu === item.name ? "active-menu" : ""
                    }`}
                  >
                    {item.name}
                  </div>
                </div>
              </Link>
            )
        )}
      </div>
    </div>
  );
};

export default DropdownMenuController;
